import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
//theme
import theme from "../../../styles/theme.semantic";

const Input = styled.input`
  height: ${props => props.height || theme.components.input.height};
  width: ${props => props.width || "100%"};
  border: ${props => props.border || "none"};
  font-size: ${props => props.fontSize || theme.components.input.fontSize};
  padding: 0 8px 0 8px;

  :focus {
    outline: 2px solid ${props => props.theme.components.input.focus};
  }

  ::placeholder {
    color: ${props => props.color || theme.components.input.color};
  }
`;

Input.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  border: PropTypes.string,
  fontSize: PropTypes.string,
  color: PropTypes.string
};

export default Input;
